import { Theme } from "@mui/material";
import { colors } from "../../../constants/colors";

const styles = {
  backgroundColor: colors.white,
  '& #hero-title': {
    color: colors.black,
  },
  '& #hero-description': {
    color: colors.black,
  },
  '& a': {
    color: colors.secondary,
  }
};

const heroStyles: any = (theme?: Theme) => styles;

export default heroStyles;